import optimizeCb from './_optimizeCb.js';

// Run a function **n** times.
export default function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = optimizeCb(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/times.js
// module id = 882
// module chunks = 115